import { Button } from "primereact/button";
import { OverlayPanel } from "primereact/overlaypanel";
import { classNames } from "primereact/utils";

import { ConfirmDialog, FilterPanel } from "@/ds";
import { PANEL_FLUSH_CLASS } from "./filters-popover.constants";
import styles from "./filters-popover.module.scss";
import type { FiltersPopoverViewModel } from "./types-filters-popover";

export function FiltersPopoverView({
  overlay,
  root,
  fieldTestId,
  trigger,
  panel,
  saved,
}: FiltersPopoverViewModel) {
  return (
    <div className={styles.field} data-testid={fieldTestId}>
      <FilterPanel.Root {...root} collapsible={false}>
        <Button
          type="button"
          icon="pi pi-filter"
          label={trigger.label}
          // Com o painel fechado, o contador é a única pista de que há critérios aplicados.
          badge={trigger.badge}
          severity="secondary"
          size={trigger.size}
          className={trigger.className}
          aria-haspopup="true"
          aria-expanded={trigger.expanded}
          aria-label={trigger.ariaLabel}
          onClick={trigger.alternar}
          data-testid={trigger.testId}
        />

        <OverlayPanel
          ref={overlay}
          className={classNames(PANEL_FLUSH_CLASS, styles.panel)}
          onShow={panel.abrir}
          onHide={panel.fechar}
          dismissable
          // O Esc é do `useFiltersPopover`: o do OverlayPanel fecharia o painel junto com o dropdown aberto.
          closeOnEscape={false}
        >
          <FilterPanel.Card>
            <FilterPanel.Header>
              {saved ? (
                <FilterPanel.SavedList
                  saved={saved.savedFilters}
                  onSelect={saved.onSelect}
                  onDelete={saved.pedirExclusao}
                />
              ) : null}
            </FilterPanel.Header>
            <FilterPanel.Rows />
            <FilterPanel.Footer>
              <FilterPanel.AddButton />
              {saved ? (
                <FilterPanel.SaveButton saved={saved.savedFilters} onClick={saved.abrirSalvar} />
              ) : null}
            </FilterPanel.Footer>
          </FilterPanel.Card>
        </OverlayPanel>

        {saved ? (
          <div onClick={saved.isolarClique}>
            <FilterPanel.SaveDialog
              visible={saved.salvarAberto}
              onClose={saved.fecharSalvar}
              onSave={saved.salvar}
              savedFilters={saved.savedFilters}
            />
            <ConfirmDialog
              visible={saved.exclusao.visible}
              onHide={saved.exclusao.cancelar}
              header={saved.exclusao.header}
              message={saved.exclusao.message}
              variant="destructive"
              acceptLabel={saved.exclusao.acceptLabel}
              accept={saved.exclusao.confirmar}
              testId={saved.exclusao.testId}
            />
          </div>
        ) : null}
      </FilterPanel.Root>
    </div>
  );
}
